module.exports = __webpack_public_path__ + "img/menu4.420af087.jpg";